
import config from '@/../config'
// 配置
Object.assign(config, {
	name: '管理系统',
})

export default config
